<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [isReadOnly]="true"
></wm-form-activity-input-view>